import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tempData: {}, 
};

const bookingFormSlice = createSlice({
  name: "bookingForm",
  initialState,
  reducers: {
    updateTempForm(state, action) {
      const { booking_id, data } = action.payload;

      if (!booking_id) return;

    
      if (!state.tempData[booking_id]) {
        state.tempData[booking_id] = {};
      }

     
      state.tempData[booking_id] = {
        ...state.tempData[booking_id],
        ...data,
      };
    },

    clearTempForm(state, action) {
      const booking_id = action.payload;
      if (booking_id && state.tempData[booking_id]) {
        delete state.tempData[booking_id];
      }
    },

    clearAllForms(state) {
      state.tempData = {};
    },
  },
});

export const { updateTempForm, clearTempForm, clearAllForms } =
  bookingFormSlice.actions;

export default bookingFormSlice.reducer;
